import Swal from "sweetalert2";
//notificacion en el esquina superior derecha 
export const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });

  //mensaje de alerta en el centro de la pantalla, espera confirmacion
  export const Alerta = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: true
  });

  export const Confirm = Swal.mixin({
    toast: true,
    position: "center",
    showCancelButton:true,
    showConfirmButton:true,
  })